import React, { useMemo } from 'react';

import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

import { AccordionFAQ } from './accordion/accordionFAQ';
import data from './data.json';

import * as ST from './styled';

const Index: React.FC = () => {
    const clientSide = isClientSide();
    const remoteDiagnosticLink: undefined | JSX.Element =  useMemo(() => {
        if (data.remoteDiag && clientSide) {
            const os: Record<string, string> = {
                win10: 'Windows NT 10.0',
                win8_1: 'Windows NT 6.3',
                win8_0: 'Windows NT 6.2',
                win7: 'Windows NT 6.1',
                winVista: 'Windows NT 6.0',
            };

            const modernVersion = ['win10', 'win8_0', 'win8_1'];

            const version = window.navigator.appVersion;
            let href = '';

            for (const [key, value] of Object.entries(os)) {
                if (version.indexOf(value) !== -1) {
                    href = modernVersion.includes(key)
                        ? 'https://sos.dom.ru/file-share/test(win8-10-11).exe'
                        : 'https://sos.dom.ru/file-share/test(win7).exe';
                    break;
                }
            }

            return href ? <a href={href}>Наше приложение</a> : <span>Наше приложение</span>;
        }

    }, [clientSide]);

    return (
        <ST.ClientPage>
            <ST.Widget>
                <ST.WidgetContent>
                    <ST.TitleH1>Проверить скорость интернета</ST.TitleH1>
                    <ST.WidgetWrap>
                        <iframe
                            width='100%'
                            height='650px'
                            frameBorder='0'
                            title='Speedtest widget'
                            src='https://domru.speedtestcustom.com'
                        />
                        <ST.FrameTitle>Для максимально точного результата</ST.FrameTitle>
                        <ST.FrameDescription>{data.client.frame.desc}</ST.FrameDescription>
                    </ST.WidgetWrap>
                    <ST.FAQ>
                        <ST.FAQTitle>Часто задаваемые вопросы по скорости интернета</ST.FAQTitle>
                        <ST.FAQContent>
                            <AccordionFAQ
                                ask={data.remoteDiag.ask}
                                response={<>
                                    {remoteDiagnosticLink}
                                    {data.remoteDiag.response}
                                </>}
                                responseUL={data.remoteDiag?.responseUL}
                            />
                            {data.client.faq.content.map((item, index) => (
                                <AccordionFAQ
                                    ask={item.ask}
                                    response={item?.response}
                                    responseUL={item?.responseUL}
                                    response2={item?.response2}
                                    multiLevelContentItem={item.content ? item : undefined}
                                    key={index}
                                />))
                            }
                        </ST.FAQContent>
                    </ST.FAQ>
                </ST.WidgetContent>
            </ST.Widget>
        </ST.ClientPage>
    );
};

export default Index;
